import React from 'react';
import PropTypes from 'prop-types';

function Member(props) {
    return (
        <div id="member-container">
            <div className="profile-picture">
                <img src={props.image} className="round" alt="Profile"/>
            </div>
            <div className="text-center pt-4">
                <span className="d-block memberDetails--name">{props.name}</span>
                <span className="d-block memberDetails--code">Socio No. {props.memberNo}</span>
            </div>
        </div>
    );
}

Member.propTypes = {
    name: PropTypes.string.isRequired,
    memberNo: PropTypes.string.isRequired,
}
export default Member;



// WEBPACK FOOTER //
// ./src/Components/Profile/member.js